import React, { Component } from 'react';

import Loading from './Loading';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

class EB04PrintContent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Action:{
                PreviewFile: {}
            },
            Datasets: {},
            loading: false
        };
        this.updateState = this.setState.bind(this);
    }

    loadDatasets = async () => {
        let { id } = this.props;

        let sets = [
            { key: "certification_eb_04", filter: [{ field: "training_details_enterprise_eb_03_id", value: id }] },
            { key: "certification_training_list_eb_04", filter: [{ field: "training_details_enterprise_eb_03_id", value: id }] },
        ];
        await Actions.loadDatasets(this.updateState, sets);

        this.setState({loading: false});
    }    

    initialize = async () => { 
        await this.loadDatasets(); 
    }

    componentDidMount = async () => { await this.initialize(); }

    componentDidUpdate = async () => { }        

    render = () => {

        let { Action } = this.state;

        const { id } = this.props;

        let { Datasets } = this.state;
        let ds = Datasets;

        let ceb = ds?.certification_eb_04 || {};
        if (ceb[0]) { ceb = ceb[0]; }

        ceb = Object.fromEntries(Object.entries(ceb).map(([key, value]) => [key, util.renderText(value)]));
        
        let ctleb = (ds.certification_training_list_eb_04 || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));
        
        let training_date = (() => {
            const { training_start_date, training_end_date } = ceb;

            const start = util.parseDate(util.convertDateToBE(training_start_date));
            const end = util.parseDate(util.convertDateToBE(training_end_date));

            return util.displayDateRange(start, end);
        })();

        let footerSection = (
            <>
                {ceb.evidence && (     
                    <>
                        เอกสารหลักฐาน
                        <span className="ms-2 mb-0 text-primary text-14px underline"
                            style={{ cursor: 'pointer' }}
                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: ceb.evidence})}
                        >
                            {ceb.evidence_file_name}
                        </span>
                    </>                                                                             

                )}

                <p><u>หมายเหตุ</u></p>
                <p>* บริษัทฯ ชำระค่าลงทะเบียนให้ผู้เข้ารับการอบรมรวม {util.printText(util.formatNumber(ceb.paid_trainee_count))} คน เป็นจำนวนเงิน {util.printText(util.formatNumber(ceb.amount))} บาท ครบถ้วนแล้ว</p>   
                <p>** ผู้เข้ารับการอบรมข้างต้นที่ผ่านเกณฑ์การประเมิน บริษัทฯ ยินดีรับรองการจ้างงานต่อเนื่องเป็นระยะเวลาไม่น้อยกว่า 1 ปี</p>    
                <p>*** ข้าพเจ้าฯ ขอรับรองว่าข้อความและเอกสารข้างต้นเป็นความจริงทุกประการ</p>     

                <div className="signature-grid-accurate mt-2 mb-4">
                    <div className="signature-box"></div>
                    <div className="signature-box">
                        <p className="text-center" style={{minHeight: '80px'}}>{util.printText('     ')}</p>
                        <p className="text-center">( {util.printText(ceb.fullname)} )</p>
                        <p className="text-center">ตำแหน่ง {util.printText(ceb.position)}</p>
                        <p className="text-center">วัน/เดือน/ปี พ.ศ. {util.printText(util.convertDateToTextBE(ceb.form_date))}</p>                                        
                    </div>
                </div>                      
            </>
        );

        const ITEMS_PER_PAGE = 20; 

        const chunkArray = (array, size) => {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        };

        const ctlebChunks = chunkArray(ctleb, ITEMS_PER_PAGE);        

        return this.state.loading ? (
            <Loading />
        ) : (
            <>
                <div className="print-container">
                    {ctlebChunks.map((chunk, pageIndex) => (
                        <div key={pageIndex} className="print-page">
                            {pageIndex === 0 && (
                                <>
                                    <h6 className="text-end">สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)</h6>
                                    <h6 className="text-end mb-4">EB-04 เอกสารรับรองจากสถานประกอบการฯ Version 2.1</h6>
                                    <h4 className="text-center">
                                        <b>เอกสารรับรองจากสถานประกอบการที่เข้ารับการอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</b>
                                    </h4>

                                    <p>บริษัท {util.printText(ceb.enterprise_name)} ขอรับรองว่า ได้ส่งบุคลากรในสังกัดเข้ารับการอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</p>
                                    <p>ในหลักสูตร {util.printText(ceb.course_eb_03_name)}</p>
                                    <p>รหัสหลักสูตร {util.printText(ceb.official_course_code)} จัดโดยสถานศึกษาชื่อ {util.printText(ceb.academy_name)}</p>
                                    <p>
                                        ในระหว่างวันที่ {util.printText(training_date)} มีจำนวนผู้เข้ารับการอบรมรวม {util.printText(util.formatNumber(ctleb?.length))} คน ดังรายชื่อต่อไปนี้
                                    </p>
                                </>
                            )}

                            <table className="print-table-border mt-4 mb-4">
                                <thead>
                                    <tr>
                                        <td className="text-center text-14px" style={{ width: '5%' }}>ที่</td>
                                        <td className="text-center text-14px" style={{ width: 'auto' }}>ชื่อ-สกุล</td>
                                        <td className="text-center text-14px" style={{ width: '20%' }}>หมายเลขบัตรประชาชน</td>
                                        <td className="text-center text-14px" style={{ width: '30%' }}>ตำแหน่ง</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((exp, i) => (
                                        <tr key={exp.id}>
                                            <td className="text-center text-14px">{pageIndex * ITEMS_PER_PAGE + i + 1}</td>
                                            <td className="text-14px">{exp.fullname}</td>
                                            <td className="text-center text-14px">{exp.cardid}</td>
                                            <td className="text-14px">{exp.position_before_training}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {pageIndex === ctlebChunks.length - 1 && footerSection}
                        </div>
                    ))}
                </div>
            </>
        )
    }

}

export default EB04PrintContent;